export default [
  {
    path: '/quoting/:type/underwriting',
    name: 'smeUnderwriting',
    component: () => import('@/views/quoting/smeUnderwriting'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/quoting/:type/buy/policy',
    name: 'smeBuyPolicy',
    component: () => import('@/views/quoting/sme-buy-policy'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/quoting/:type/refer',
    name: 'smeRefer',
    component: () => import('@/views/quoting/smeRefer'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/quoting/quote/:type/refer/information',
    name: 'smeRefer',
    component: () => import('@/views/quoting/smeReferInformation'),
    meta: {
      keepAlive: false
    }
  },
]
